<template>
  <div class2="colocar_container ? 'container' : ''">

    <div class="mt-3 text-center" v-if="!firstLoadDone">
      <az-loading msg="Carregando Relatório..." />
    </div>

    <div v-else-if="!relatorio">
      <div class="alert alert-danger" v-if="!relatorio">
        <h3 class="alert-heading mb-3">
          Falha na abertura do relatório
        </h3>
        <div v-if="msg_erro">
          {{ msg_erro }}
        </div>
      </div>

      <router-link class="btn btn-outline-secondary my-3" :to="{ path: '/relatorio/editor/' + id }" data-dismiss="modal" v-if="!inportal">
        <i class="fa fa-cog" aria-hidden="true"></i>
      </router-link>
    </div>

    <div v-else>

      <div class="card dashcard mb-1" style="padding: 0px;">
        <div class="card-header lead d-flex justify-content-between">
          <div>
            {{ relatorio.title }}
          </div>
          <div v-if="dash_id">
            <router-link :to="{ name: 'custom-dashboard', params: { id: dash_id } }" class="card-link" title="Retornar ao Dashboard" v-if="dash_id">
              <i class="fa-solid fa-angle-left"></i>
            </router-link>
          </div>
          <div v-else-if="backlink && ( !pparms || !pparms.inmodal )">
            <router-link :to="{ path: backlink }" class="card-link" title="Retornar ao Dashboard">
              <i class="fa-solid fa-angle-left"></i>
            </router-link>
          </div>
          <div v-else>
            <!-- Modo Painel -->
            <div class="btn-group dropleft mr-1">
                <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle" data-toggle="dropdown" aria-expanded="false" title="Modo Painel">
                    <i class="fas fa-tv fa-fw"></i>
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" href="#" @click.prevent="ativar_painel(1)">Modo Painel (Atualização de 1/1 min)</a>
                    <a class="dropdown-item" href="#" @click.prevent="ativar_painel(2)">Modo Painel (Atualização de 2/2 min)</a>
                    <a class="dropdown-item" href="#" @click.prevent="ativar_painel(5)">Modo Painel (Atualização de 5/5 min)</a>
                </div>
            </div>

            <button type="button" class="btn btn-sm btn-outline-secondary" @click="fonte_menor = !fonte_menor" data-toggle="tooltip" data-placement="top" title="Tamanho da Fonte">
              <i class="fa-solid fa-text-size"></i>
            </button>
          </div>
        </div>

        <div class="card-body py-1">
          <!-- Parâmetros -->
          <parametros-relatorio ref="parametros" v-model="relatorio.inputs" :etiquetas="relatorio.etiquetas ? relatorio.etiquetas : []" @imprimir="printTabela" @imprimirEtiqueta="printEtiqueta" @carregar="load" v-if="relatorio.inputs">
            <button class="btn btn-outline-secondary my-3 mr-2" type="button" @click="load()"
              :disabled="$store.state.loading"
              data-toggle="tooltip" data-placement="top" title="Buscar" id="refresh-button">
              <i class="fas fa-sync-alt"></i>
            </button>
            <div class="dropdown my-3 mr-2">
              <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-arrow-down mr-1"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <JsonExcel
                  class="dropdown-item"
                  type="csv"
                  :data="dadosFormatados">
                  Download Arquivo CSV
                </JsonExcel>
                <JsonExcel
                  class="dropdown-item"
                  :data="dadosFormatados">
                  Download Arquivo Excel
                </JsonExcel>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#" @click.prevent="compartilhar()">Compartilhar por E-mail</a>
              </div>
            </div>
            <button type="button" class="btn my-3" :class="ordenar ? ' btn-secondary' : ' btn-outline-secondary'" @click="ordenar = !ordenar"
              title="Ordenar">
              <i class="fas fa-sort-alpha-down"></i>
            </button>

            <!-- Configuração -->
            <template v-if="!inportal">
                <router-link class="btn btn-outline-secondary ml-2 my-3" :to="{ path: '/relatorio/editor/' + relatorio.id }" v-if="relatorio.id_query_meta">
                    <i class="fa fa-cog" aria-hidden="true"></i>
                </router-link>
                <button type="button" class="btn ml-2 my-3 btn-outline-secondary" @click="acessos()" v-else-if="!linked">
                    <i class="fas fa-user-lock"></i>
                </button>
            </template>
          </parametros-relatorio>
        </div>

        <div class="card-footer" v-if="filtros.length">
          <div class="btn-group mb-2 mr-2" role="group" aria-label="Basic example" v-for="(filtro, ifl) in filtros" :key="ifl">
            <button type="button" class="btn btn-outline-primary btn-sm">
              {{ filtro.campo.title }} {{ filtro.tipo == 'E' ? '!=' : '=' }} {{ filtro.valor }}
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm" @click="removerFiltro(ifl)">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="progress mt-1 mb-3">
        <div class="indeterminate" v-if="$store.state.loading"></div>
        <div class="determinate" v-else></div>
      </div>

      <pre v-if="1 == 0">{{ relatorio }}</pre>

      <div :class="tempo_painel ? 'card panel-fullscreen' : ''">

        <div v-if="tempo_painel" class="card-header d-flex justify-content-between">
            <div class="lead" v-if="relatorio">
                {{ relatorio.title }}
            </div>
            <div>
                <span class="mr-3" v-if="$store.state.loading">
                    <div class="spinner-grow spinner-grow-sm" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </span>
                <span class="mr-3 small text-muted" v-if="atualizacao">Atualizado em: {{ atualizacao }}</span>
                <a href="#" @click.prevent="fechar_painel()">
                    <i class="fa-solid fa-xmark"></i>
                </a>
            </div>
        </div>

        <div :class="tempo_painel ? 'card-body p-1' : ''">

            <div v-if="relatorio && relatorio.error">
                <div class="alert alert-danger">
                    <div>
                        <a href="#" @click.prevent="exibir_falha = !exibir_falha" class="mr-2" v-if="relatorio.error && relatorio.error != '.'">
                            <i class="fa fa-plus-square-o fa-fw" aria-hidden="true" v-if="!exibir_falha"></i>
                            <i class="fa fa-minus-square-o fa-fw" aria-hidden="true" v-else></i>
                        </a>
                        <span>Falha na busca do relatório</span>
                    </div>
                    <template v-if="exibir_falha">
                        <hr>
                        <pre>{{ tratar_erro(relatorio.error) }}</pre>
                    </template>
                </div>
            </div>

            <div v-if="over_limit || ( !relatorio.result )">
                <!-- action="Download CSV" :method="load_csv" -->
                <az-empty-state msg="Excesso de registros." icon="fas fa-fill-drip" v-if="over_limit"
                action="Download CSV" :method="load_csv"
                ></az-empty-state>
                <az-empty-state msg="Nenhum dado encontrado." v-else></az-empty-state>

            </div>

            <template v-else>

                <div class="d-flex justify-content-center mb-3" v-if="relatorio && relatorio.dimensoes && relatorio.dimensoes.length">
                    <ul class="nav nav-pills">
                        <li class="nav-item" v-for="(dimensao, idx) in relatorio.dimensoes" :key="idx">
                            <a href="#" class="nav-link" :class="( dimensao.selecionada ? 'active': '' ) + ( $store.state.loading ? ' disabled' : '' )" @click.prevent="dimensao_selecao(idx)">
                                {{ dimensao.title }}
                            </a>
                        </li>
                    </ul>
                </div>

                <!-- Campanhas -->
                <div class="mb-3">
                <span v-for="(campanha, icamp) in relatorio.campanhas" :key="icamp">
                    <button type="button" class="btn btn-outline-info mr-1" v-if="campanha.type == 'chat_id'" @click="campanha_selecao(campanha)">
                    <i class="fab fa-telegram-plane mr-2"></i>
                    Enviar Mensagens pelo Telegram
                    </button>
                    <button type="button" class="btn btn-outline-primary mr-1" v-if="campanha.type == 'email'" @click="campanha_selecao(campanha)">
                    <i class="fa fa-envelope mr-2" aria-hidden="true"></i>
                    Enviar e-mails
                    </button>
                    <button type="button" class="btn btn-outline-success mr-1" v-if="campanha.type == 'fone'" @click="campanha_selecao(campanha)">
                    <i class="fas fa-sms mr-2"></i>
                    Enviar SMSs
                    </button>
                    <button type="button" class="btn btn-outline-success mr-1" v-if="campanha.type == 'fone' && 1 == 0" @click="campanha_selecao(campanha)">
                    <i class="fa fa-whatsapp mr-2" aria-hidden="true"></i>
                    Enviar WhatsApp
                    </button>
                </span>
                </div>

                <template v-if="!( relatorio.pivot && relatorio.result && relatorio.result.columns.length == 3 ) && relatorio.tem_analitico">
                <div class="row">
                    <div class="col col-12 d-flex flex-column">
                    <az-input
                        sizing="sm"
                        type="button-group"
                        :optionsList="[
                        { id: 'S', search: 'Sintético' },
                        { id: 'A', search: 'Analítico' },
                        ]"
                        optionsData="id"
                        v-model="tipo_detalhe"
                        @click="nextload()" />
                    </div>
                </div>
                </template>

                <!-- RELATÓRIO / TABELA -->
                <div id="tabela-to-print" ref="ttp">

                    <div>

                        <template v-if="relatorio.pivot && relatorio.result && relatorio.result.columns.length == 3">
                            <table class="table table-sm" :class="cabecalhofixo + ( printable ? '' : ' table-hover table-responsive-md' )">
                                <thead class="thead-dark">
                                    <tr class="table-dark">
                                        <th>{{ relatorio.result.columns[0].title }}</th>
                                        <th v-for="(coluna, icx) in listar(relatorio.result.columns[1])" :key="icx" class="text-right">
                                            {{ coluna.label }}
                                        </th>
                                        <th class="text-right">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="table-light" v-for="(valores, linha, ilx) in groupedData" :key="ilx">
                                    <td>{{ linha }}</td>
                                    <td v-for="(coluna, icx) in listar(relatorio.result.columns[1])" :key="icx" class="text-right">
                                        {{ formatar(relatorio.result.columns[2], totalizar_pivot(valores, relatorio.result.columns[1], coluna.label)) }}
                                    </td>
                                    <th class="text-right">
                                        {{ formatar(relatorio.result.columns[2], totalizar_pivot(valores)) }}
                                    </th>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr class="bg-dark text-white">
                                        <th>Total</th>
                                        <th v-for="(coluna, icx) in listar(relatorio.result.columns[1])" :key="icx" class="text-right">
                                            {{ formatar(relatorio.result.columns[2], totalizar_pivot(dadosFiltrados, relatorio.result.columns[1], coluna.label)) }}
                                        </th>
                                        <th class="text-right">
                                            {{ formatar(relatorio.result.columns[2], totalizar_pivot(dadosFiltrados)) }}
                                        </th>
                                    </tr>
                                </tfoot>
                            </table>
                        </template>

                        <table class="table table-sm" :class="( printable ? '' : 'table-hover ' + ( relatorio.result.columns.length > 12 ? 'table-responsive' : 'table-responsive-md ' + cabecalhofixo ) ) + ( fonte_menor ? ' small' : '' )" v-else-if="relatorio.result">
                            <thead class="thead-dark">
                            <tr>
                                <td :colspan="relatorio.result.columns.length">
                                    <!-- Header da tabela para impressao -->
                                    <div v-if="printable" class="d-flex flex-column mb-1" style="min-height:4cm;">
                                        <header-relatorio :forceheader="true" :parms="{nome_contratado, codigo_contratado, unidade_relatorio}" :logo_url="logo_url" :endereco="relatorio.endereco" />
                                        <div class="text-primary font-weight-bold mx-auto mt-3 h-2">{{relatorio.title}}</div>
                                        <div v-if="filtros.length">
                                            Filtros:
                                            <div class="d-flex flex-row">
                                                <div v-for="(filtro, ifl) in filtros" :key="ifl" class="mr-2">
                                                {{ filtro.campo.title }}
                                                {{ filtro.tipo == 'E' ? '!=' : '=' }}
                                                {{ filtro.valor }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-flex flex-row justify-content-between">
                                        <pre v-if="false">{{ parmsFilled }}</pre>
                                        <div>
                                        <div v-for="(val,name) in parmsFilled " :key="name" class="mr-2 text-dark d-flex">
                                            <span class="mr-2" :style="printableFont">{{name}}:</span>
                                            <strong :style="printableFont">{{val}}</strong>
                                        </div>
                                        </div>
                                        <div>
                                        <span class="badge badge-secondary" v-if="relatorio.result.data">
                                            {{ relatorio.result.data.length }}
                                            {{ relatorio.result.data.length == 1 ? ' linha' : ' linhas' }}
                                        </span>

                                        <a href="#" @click.prevent="sintetico = !sintetico" class="card-link ml-3" v-if="relatorio.result.group_cols.length > 0">
                                            <i class="fa-solid fa-minimize fa-fw" v-if="!sintetico"></i>
                                            <i class="fa-solid fa-maximize fa-fw" v-else></i>
                                        </a>

                                        </div>
                                    </div>
                                    <!-- Final Header Print -->
                                </td>
                            </tr>

                            <tr>
                                <template v-for="(coluna, ic) in relatorio.result.columns">
                                    <table-th v-model="ordem" :sortby="coluna.name" :align="'text-' + coluna.align" :link_class="printable ? 'text-dark' : 'text-white'" :key="ic" :noshow="!ordenar" v-if="true"> <!-- || coluna.type == 'value' -->
                                        <a href="#" @click.prevent="addFiltroModal(coluna)" class="card-link" :class="printable ? '' : 'text-white'" :style="printableFont">
                                            {{ coluna.title }}
                                        </a>
                                    </table-th>

                                    <th :class="'text-' + coluna.align" :key="'percent' + ic" class="text-white" v-if="coluna.percent">
                                        %
                                    </th>
                                </template>
                            </tr>
                            </thead>

                            <!-- Relatório sem quebra -->
                            <tbody v-if="relatorio.result.group_cols.length == 0">
                                <tr v-for="(linha, il) in groupedData" :key="il" class="table-light">
                                    <template v-for="(coluna, ic) in relatorio.result.columns">
                                        <td :key="ic" :class="'text-' + coluna.align" :style="printableFont" v-if="true">
                                            <template v-if="relatorio.edit == 'C'">
                                                <template v-if="ic && coluna.name && coluna.name.slice(-4) !=  'view'">
                                                    <az-input sizing="sm" v-model="linha[coluna.name]" />
                                                </template>
                                                <template v-else-if="ic && coluna.name && coluna.name.slice(-4) ==  'view'">
                                                    {{ linha[coluna.name] }}
                                                </template>
                                                <template v-else>
                                                    <button type="button" class="btn btn-outline-success btn-sm mr-1" @click="atualizar_linha(linha)">
                                                    <i class="fa fa-check" aria-hidden="true"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-outline-danger btn-sm mr-1" @click="atualizar_linha(linha, true)">
                                                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                                                    </button>
                                                    <span class="ml-2">
                                                        {{ formatar ( coluna, linha[coluna.name] ) }}
                                                    </span>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="printable">
                                                    <template v-if="coluna && coluna.format == 'bc' && groupedData.length <= 200">
                                                        <img :src="'https://barcode.tec-it.com/barcode.ashx?data=' + linha[coluna.name] + '&code=Code128&translate-esc=true&width=50&height=10&hidehrt=on'" alt="Código de Barras">
                                                    </template>
                                                    <template v-else>
                                                        {{ formatar ( coluna, linha[coluna.name] ) }}
                                                    </template>
                                                </template>

                                                <a href="#" @click.prevent="addFiltro(coluna, linha[coluna.name])" :style="printableFont" v-else>
                                                    <template v-if="coluna && coluna.format == 'bc' && groupedData.length <= 200">
                                                        <img :src="'https://barcode.tec-it.com/barcode.ashx?data=' + linha[coluna.name] + '&code=Code128&translate-esc=true&width=50&height=10&hidehrt=on'" alt="Código de Barras">
                                                    </template>
                                                    <template v-else>
                                                        {{ formatar ( coluna, linha[coluna.name] ) }}
                                                    </template>
                                                </a>
                                            </template>
                                        </td>

                                        <td v-if="coluna.percent" :key="'percent-l' + ic" class="text-right small">
                                            {{
                                                $util.formatMoeda(
                                                    calc_percent(
                                                        totalizar (groupedData, coluna.name, relatorio.result.group_cols.length),
                                                        linha[coluna.name]
                                                    )
                                                )
                                            }}%
                                        </td>
                                    </template>
                                </tr>
                            </tbody>

                            <!-- Relatório com 1 quebra -->
                            <tbody v-else-if="relatorio.result.group_cols.length == 1">
                                <template v-for="(g1, ig1, ig1_index) in groupedData">
                                    <tr :key="'tot-hspace-' + ig1" v-if="!ig1_index">
                                        <td :colspan="relatorio.result.columns.length"></td>
                                    </tr>

                                    <template v-if="sintetico">
                                        <relatorio-sub-total :titulo="ig1" :relatorio="relatorio" :tem_totalizacao="tem_totalizacao" :printableFont="printableFont" :dados="g1" :key="'subtot-' + ig1 + '|' + ig1_index" />
                                    </template>
                                    <template v-else>
                                        <relatorio-quebra :key="ig1" :quebra="ig1" :nivel="0" :relatorio="relatorio" :printableFont="printableFont" :addFiltroByGroup="addFiltroByGroup" :dadosgrupo="g1" :printable="printable" />
                                        <relatorio-linhas v-for="(linha, il) in g1" :key="ig1 + '|' + il" :linha="linha" :relatorio="relatorio" :addFiltro="addFiltro" :printableFont="printableFont" :dados="g1" :printable="printable" />
                                        <relatorio-sub-total :relatorio="relatorio" :tem_totalizacao="tem_totalizacao" :printableFont="printableFont" :dados="g1" :key="'subtot-' + ig1 + '|' + ig1_index" :printable="printable" />
                                    </template>

                                    <tr :key="'tot-fspace-' + ig1" v-if="true">
                                        <td :colspan="relatorio.result.columns.length">
                                        </td>
                                    </tr>
                                </template>
                            </tbody>

                            <!-- Relatório com 2 quebras -->
                            <tbody v-else-if="relatorio.result.group_cols.length == 2">
                            <template v-for="(g1, ig1, ig1_index) in groupedData">
                                <tr :key="'tot-hspace-' + ig1" v-if="!ig1_index">
                                    <td :colspan="relatorio.result.columns.length"></td>
                                </tr>

                                <relatorio-quebra :key="ig1" :quebra="ig1" :nivel="0" :relatorio="relatorio" :printableFont="printableFont" :addFiltroByGroup="addFiltroByGroup" v-if="true" :dadosgrupo="g1" :printable="printable" />

                                <template v-for="(g2, ig2, ig2_index) in g1">
                                <template v-if="sintetico"> <!-- v-if="condensar(g2)"> -->
                                    <relatorio-sub-total :titulo="ig2" :relatorio="relatorio" :tem_totalizacao="tem_totalizacao" :printableFont="printableFont" :dados="g2" :key="'tot-' + ig1 + '|' + ig2 + '|' + ig2_index" :nivel="1" :printable="printable"/>
                                </template>
                                <template v-else>
                                    <relatorio-quebra :key="ig1 + '|' + ig2" :quebra="ig2" :nivel="1" :relatorio="relatorio" :printableFont="printableFont" :addFiltroByGroup="addFiltroByGroup" :dadosgrupo="g2" :printable="printable" />
                                    <relatorio-linhas v-for="(linha, il) in g2" :key="ig1 + '|' + ig2 + '|' + il" :linha="linha" :relatorio="relatorio" :addFiltro="addFiltro" :printableFont="printableFont" :dados="g2" :printable="printable" />
                                    <relatorio-sub-total :relatorio="relatorio" :tem_totalizacao="tem_totalizacao" :printableFont="printableFont" :dados="g2" :key="'tot-' + ig1 + '|' + ig2 + '|' + ig2_index" :nivel="1" :printable="printable" />
                                </template>

                                </template>

                                <relatorio-sub-total :relatorio="relatorio" :tem_totalizacao="tem_totalizacao" :printableFont="printableFont" :dados="g1" :key="'subtot-' + ig1" :nivel="0" :agrupamento="1" v-if="true" :printable="printable" />

                                <tr :key="'tot-fspace-' + ig1" v-if="true">
                                <td :colspan="relatorio.result.columns.length">
                                </td>
                                </tr>
                            </template>
                            </tbody>

                            <!-- Relatório com 3 quebras -->
                            <tbody v-else-if="relatorio.result.group_cols.length == 3">
                            <template v-for="(g1, ig1, ig1_index) in groupedData">
                                <tr :key="'tot-hspace-' + ig1" v-if="!ig1_index">
                                    <td :colspan="relatorio.result.columns.length">
                                    </td>
                                </tr>

                                <!--
                                <relatorio-quebra :key="ig1" :quebra="ig1" :nivel="0" :relatorio="relatorio" :printableFont="printableFont" :addFiltroByGroup="addFiltroByGroup" />
                                -->
                                <relatorio-sub-total :titulo="ig1" :relatorio="relatorio" :tem_totalizacao="tem_totalizacao" :printableFont="printableFont" :dados="g1" :key="'subtot2-' + ig1" :nivel="0" :agrupamento="2" v-if="true" />

                                <template v-for="(g2, ig2, ig2_index) in g1">
                                <!--
                                <relatorio-quebra :key="ig1 + '|' + ig2" :quebra="ig2" :nivel="1" :relatorio="relatorio" :printableFont="printableFont" :addFiltroByGroup="addFiltroByGroup" />
                                -->
                                <relatorio-sub-total :titulo="ig2" :relatorio="relatorio" :tem_totalizacao="tem_totalizacao" :printableFont="printableFont" :dados="g2" :key="'subtot1-' + ig1 + '|' + ig2 + '|' + ig2_index" :nivel="1" :agrupamento="1" v-if="true" />

                                <template v-for="(g3, ig3, ig3_index) in g2">
                                    <template v-if="sintetico"> <!-- v-if="condensar(g2)"> -->
                                        <relatorio-sub-total :titulo="ig3" :relatorio="relatorio" :tem_totalizacao="tem_totalizacao" :printableFont="printableFont" :dados="g3" :key="'subtot-' + ig1 + '|' + ig2 + '|' + ig3_index" :nivel="2" />
                                    </template>
                                    <template v-else>
                                        <relatorio-quebra v-if="false" :key="ig1 + '|' + ig2 + '|' + ig3" :quebra="ig3" :nivel="2" :relatorio="relatorio" :printableFont="printableFont" :addFiltroByGroup="addFiltroByGroup" :dadosgrupo="g3"/>
                                        <relatorio-sub-total :titulo="ig3" :relatorio="relatorio" :tem_totalizacao="tem_totalizacao" :printableFont="printableFont" :dados="g3" :key="'subtot-' + ig1 + '|' + ig2 + '|' + ig3_index" :nivel="2" />
                                        <relatorio-linhas v-for="(linha, il) in g3" :key="ig1 + '|' + ig2 + '|' + ig3 + '|' + il" :linha="linha" :relatorio="relatorio" :addFiltro="addFiltro" :printableFont="printableFont" :dados="g3" />
                                    </template>
                                </template>

                                <!--
                                <relatorio-sub-total :titulo="ig2" :relatorio="relatorio" :tem_totalizacao="tem_totalizacao" :printableFont="printableFont" :dados="g2" :key="'subtot1-' + ig1 + '|' + ig2 + '|' + ig2_index" :nivel="1" :agrupamento="1" />
                                -->
                                </template>

                                <!--
                                <relatorio-sub-total :titulo="ig1" :relatorio="relatorio" :tem_totalizacao="tem_totalizacao" :printableFont="printableFont" :dados="g1" :key="'subtot2-' + ig1" :nivel="0" :agrupamento="2" />
                                -->

                                <tr :key="'tot-fspace-' + ig1" v-if="true">
                                    <td :colspan="relatorio.result.columns.length">
                                    </td>
                                </tr>
                            </template>

                            </tbody>

                            <!-- Mensagem para relatório com amis de 3 quebras -->
                            <tbody v-else-if="relatorio.result.group_cols.length > 3">
                            <tr>
                                <td :colspan="relatorio.result.columns.length">
                                Relatório com mais de 3 quebras não disponível!
                                </td>
                            </tr>
                            </tbody>

                            <!-- Totalização Final -->
                            <tbody class="table-dark" v-if="tem_totalizacao">
                            <tr>
                                <template v-for="(coluna, ic) in relatorio.result.columns">
                                <th :key="'total-' + ic" :class="'text-' + coluna.align" :style="printableFont" v-if="true">
                                    <span v-if="coluna.treat && coluna.type == 'value'" :style="printableFont">
                                        {{ formatar ( coluna, totalizar (groupedData, coluna.name, relatorio.result.group_cols.length, coluna) ) }}
                                    </span>
                                    <span v-else-if="!ic">TOTAL</span>
                                </th>

                                <th v-if="coluna.percent" :key="'perctot' + ic" class="text-right">
                                    &nbsp;
                                </th>
                                </template>
                            </tr>
                            </tbody>
                        </table>

                        <template v-if="relatorio.result.group_cols.length == 0 && relatorio.edit == 'C'">
                            <button type="button" class="btn btn-primary" @click="incluir_linha()">
                            <i class="fas fa-plus"></i>
                            </button>
                        </template>

                    </div>

                </div>

                <div class="row" v-if="1 == 1">
                <div
                    class="col-12 mb-3" :class="'col-md-' + ( graph.size ? graph.size : '12' )"
                    v-for="(graph, index) in relatorio.result.graphs"
                    :key="index"
                >
                    <div class="card carde">
                    <div class="card-header bg-dark text-white">
                        <strong>{{ graph.title }}</strong>
                    </div>
                    <div class="card-body">
                        <template v-if="graph.type == 'value'">
                        <table class="table">
                            <tbody>
                            <tr v-for="(label, ilx) in graph.basicData.labels" :key="ilx">
                                <td>{{ label }}</td>
                                <td>{{ graph.basicData.datasets[0].data[ilx] }}</td>
                            </tr>
                            </tbody>
                        </table>
                        </template>
                        <Chart
                        v-else
                        :type="graph.type"
                        :data="graph.basicData"
                        :options="graph.options"  />
                    </div>
                    </div>
                </div>
                </div>

            </template>
        </div>
      </div>

      <hr />

      <!-- Modal Add Filtro -->
      <div class="modal fade" id="filtroModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable" role="document">
          <div class="modal-content" v-if="campoFiltro">
            <div class="modal-header">
              <h5 class="modal-title">
                Filtrar
                {{ campoFiltro.title }}
                <span class="badge badge-secondary" v-if="opcoesFiltroSelecionadas.length">
                  {{ opcoesFiltroSelecionadas.length }}
                </span>
              </h5>
              <button type="button" class="close" aria-label="Close" @click="fechar_modal('filtroModal')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <az-input icon="fa fa-search fa-fw" sizing="sm" class="mb-3" v-model="search" placeholder="Pesquisar..." />

              <template v-if="tipo_filtro_classe">
                <az-input
                    class="mb-3"
                    type="button-group"
                    :optionsList="[
                        { id: 'A', search: 'Apenas 1' },
                        { id: 'AT', search: 'Apenas Todos' },
                        { id: 'E', search: 'Exceto 1' },
                        { id: 'ET', search: 'Exceto Todos' },
                    ]"
                    v-model="tipoFiltro" />
                
              </template>

              <template v-else>
                <az-input
                    class="mb-3"
                    type="button-group"
                    :optionsList="[
                    { id: 'A', search: 'Apenas' },
                    { id: 'E', search: 'Exceto' },
                    ]"
                    v-model="tipoFiltro" />
              </template>

              <button type="button" class="btn btn-outline-primary btn-sm mb-3" @click="toggle_todos()">Todos</button>

              <div class="row" v-for="(opt, iopt) in exibirOpcoesFiltro" :key="iopt">
                <div class="col">
                  <az-input sizing="sm" type="checkbox-group" :label="'  ' + opt.label" v-model="opt.selecionado" v-if="iopt < slice_filtro"/>
                  <label class="form form-control" v-else>...</label>
                </div>
              </div>

              <div class="alert mt-3" :class="( tipoFiltro == 'E' || tipoFiltro == 'ET' ) ? 'alert-danger' : 'alert-info'" v-if="opcoesFiltroSelecionadas.length">
                <small>
                  Selecioandos:
                  {{ ( tipoFiltro == 'E' || tipoFiltro == 'ET' ) ? '(EXCETO)' : '' }}
                  {{ opcoesFiltroSelecionadas.map(item => item.label).join(', ') }}
                </small>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="fechar_modal('filtroModal')">Cancelar</button>
              <button type="button" class="btn btn-success" @click="addFiltroFromModal()">Filtrar</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="shareReportModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Compartilhar</h5>
              <button type="button" class="close" @click="fechar_modal('shareReportModal')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col col-12">
                <az-input
                  label="e-mail"
                  type="email"
                  v-model="share_data.mail"
                  :validate="validate"
                  required />
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <az-input
                  label="Assunto"
                  type="text"
                  v-model="share_data.assunto"
                  :validate="validate"
                  required />
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <az-input
                  label="Texto"
                  type="textarea"
                  v-model="share_data.texto"
                  :validate="validate"
                  required />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="enviar()">Enviar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="textoCampanhaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="campanha">
          <div class="modal-header">
            <h5 class="modal-title">Campanha</h5>
              <button type="button" class="close" @click="fechar_modal('textoCampanhaModal')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">

            <az-input
              label="Assunto"
              class="mb-3"
              v-model="campanha.assunto"
              v-if="campanha.campanha.type == 'email'" />

            <az-input
              label="Texto"
              type="textarea"
              rows="5"
              v-model="campanha.texto" />

            <az-input
              class="mt-3"
              label="Incluir Link na Mensagem"
              type="checkbox-group"
              v-model="campanha.tem_link" />

            <az-input
              class="mt-3"
              label="Título do Link"
              v-if="campanha.tem_link"
              v-model="campanha.link_titulo" />

            <az-input
              class="mt-3"
              icon="fa fa-link"
              label="Link"
              v-if="campanha.tem_link"
              v-model="campanha.link" />

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="fechar_modal('textoCampanhaModal')">Fechar</button>
            <az-submit @click="campanha_enviar()">Enviar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <edicao-acessos ref="acessos" />

    <!-- Modal -->
    <div class="modal fade" id="camposModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="dados_campos">
          <div class="modal-header">
            <h5 class="modal-title">Campos</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <table class="table">
              <thead>
                <tr>
                  <th>Campo</th>
                  <th>Ocultar</th>
                  <th>Quebra</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(campo, nome, idx) in dados_campos" :key="idx">
                  <td>{{ campo.title }}</td>
                  <td>
                    <az-input
                      type="checkbox"
                      v-model="campo.hide" />
                  </td>
                  <td>
                    <az-input
                      v-if="campo.type != 'value' && !campo.hide"
                      type="checkbox"
                      v-model="campo.treat" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <az-submit @click="atualizar_campos()">Alterar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <template v-if="relatorio && relatorio.result && 1 == 0">
      <button type="button" class="btn btn-primary" @click="config_campos()">
        Campos
      </button>

      <ul class="list-group">
        <li class="list-group-item" v-for="(campo, nome, idx) in relatorio.result.config_cols" :key="idx">
          {{ campo.title }}
          <i class="fas fa-caret-right mx-3"></i>
          {{ campo.treat }}
        </li>
      </ul>

      <pre class="mt-3 alert alert-warning">{{ relatorio.result }}</pre>

    </template>

    <relatorio-compartilhar ref="compart" />
  </div>
</template>

<script type="text/javascript">
import _ from "lodash";
import $ from "jquery";
import * as moment from "moment";
import AzInput from "../shared/forms/AzInput.vue";
import HeaderRelatorio from './shared/HeaderRelatorio.vue';
import AzSubmit from '../util/AzSubmit.vue';
import ParametrosRelatorio from './shared/ParametrosRelatorio.vue';
import AzLoading from '../util/AzLoading.vue';
import TableTh from '../shared/table/TableTh.vue';
import EdicaoAcessos from '../cadastros/shared/EdicaoAcessos.vue';
import RelatorioLinhas from './shared/RelatorioLinhas.vue';
import RelatorioQuebra from './shared/RelatorioQuebra.vue';
import RelatorioSubTotal from './shared/RelatorioSubTotal.vue';
import RelatorioCompartilhar from './shared/RelatorioCompartilhar.vue';

export default {
  name: "Relatorio",
  props: ["pid", "pparms", "inmodal", "inportal"],
  data() {
    return {
      id: 123,
      relatorio: null,
      loading: true,
      parms: {},
      firstLoadDone: false,
      filtros: [],
      campoFiltro: null,
      printable: false,
      printableFont: {},
      breadcrumb: null,
      share_type: "mail",
      share_data: {
        mail: "",
        assunto: "",
        texto: "",
      },
      validate: false,
      msg_erro: "",
      search: "",
      campanha: null,
      ordem: "",
      ordenar: false,
      linked: false,
      opcoesFiltro: [],
      canceltoken: null,
      tipo_filtro_classe: false, 
      tipoFiltro: 'A',
      dados_campos: null,
      over_limit: false,
      dados_csv: null,
      slice_filtro: 100,
      sintetico: false,
      tipo_detalhe: 'S',
      dash_id: null,
      backlink: null, 
      logo_url: null, 
      fonte_menor: false, 
      exibir_falha: false, 
      func_refresh_painel: null, 
      tempo_painel: null,
      atualizacao: null,
    };
  },
  components: {
    AzInput,
    HeaderRelatorio,
    AzSubmit,
    ParametrosRelatorio,
    AzLoading,
    TableTh,
    EdicaoAcessos,
    RelatorioLinhas,
    RelatorioQuebra,
    RelatorioSubTotal, 
    RelatorioCompartilhar, 
  },
  computed: {
    cabecalhofixo: function () { 
        return this.inmodal ? 'cabecalho-fixo-modal' : 'cabecalho-fixo';
    }, 
    coluna_pivot: function () {
      if ( this.relatorio && this.relatorio.result && this.relatorio.result.columns ) {
        return this.relatorio.result.columns.find(item => item.pivot);
      }

      return null;
    },

    colocar_container: function () {
      if ( this.relatorio && this.relatorio.pivot && this.relatorio.result && this.relatorio.result.columns.length == 3 ) {
        return false;
      } else if ( this.relatorio && this.relatorio.result && this.relatorio.result.columns.length > 5 ) {
        return false;
      }

      return true;
    },

    tem_totalizacao: function() {
      if ( !this.relatorio || !this.relatorio.result || !this.relatorio.result.columns )
        return true;

      return this.relatorio.result.columns.findIndex(item => item.treat && item.type == 'value') >= 0;
    },

    rGroups: function() {
      if (!this.relatorio.result) return [];

      let groups = this.relatorio.result.group_cols;

      groups[4] = null;

      return groups;
    },
    dadosFiltrados: function () {
      if (!this.relatorio || !this.relatorio.result)
        return [];

      if ( this.over_limit )
        return this.relatorio.result.data;

      return this.relatorio.result.data.filter(item => {
        if (!this.filtros.length) return true;

        let nok = this.filtros.filter(filtro => {
          if (filtro.valor.length > 1) {
            if ( filtro.tipo == 'E' ) {
                return filtro.valor.find(vl => {
                    return item[filtro.campo.name] == vl || ( item[filtro.campo.name] && String(item[filtro.campo.name]).includes('"' + vl + '"') );
                });
            } else if ( filtro.tipo == 'ET' ) {
                let teste = filtro.valor.filter(vl => {
                    return item[filtro.campo.name] == vl || ( item[filtro.campo.name] && String(item[filtro.campo.name]).includes('"' + vl + '"') );
                });
                return teste.length == filtro.valor.length;  
            } else if ( filtro.tipo == 'AT' ) {
                let teste = filtro.valor.filter(vl => {
                    return item[filtro.campo.name] == vl || ( item[filtro.campo.name] && String(item[filtro.campo.name]).includes('"' + vl + '"') );
                });
                return teste.length != filtro.valor.length;  
            } else {
                return !filtro.valor.find(vl => {
                    return item[filtro.campo.name] == vl || ( item[filtro.campo.name] && String(item[filtro.campo.name]).includes('"' + vl + '"') );
                });
            }
          } else {
            if ( filtro.tipo == 'E' || filtro.tipo == 'ET' ) {
              return ( item[filtro.campo.name] == filtro.valor ) || ( item[filtro.campo.name] && String(item[filtro.campo.name]).includes('"' + filtro.valor + '"') );
            } else {
              return item[filtro.campo.name] != filtro.valor && ( !item[filtro.campo.name] || !String(item[filtro.campo.name]).includes('"' + filtro.valor + '"') );
            }
          }
        });

        return !nok.length;
      });
    },
    dadosFormatados: function () {
      if ( this.over_limit ) {
        return this.dadosFiltrados;
      }

      let lista = _.cloneDeep(this.dadosFiltrados);

      let titulos = {};

      if ( this.relatorio && this.relatorio.result && this.relatorio.result.columns ) {
        this.relatorio.result.columns.forEach((col) => {
          titulos[col.name] = col.title;
        });
      }

      if ( this.relatorio && this.relatorio.result && this.relatorio.result.group_cols ) {
        this.relatorio.result.group_cols.forEach((col) => {
          titulos[col.name] = col.title;
        });
      }

      lista = lista.map(linha => {
        let retorno = _.mapValues(linha, (coluna, nome) => {
          let info = this.relatorio.result.columns.find(col => {
            return col.name == nome;
          });
          if ( info ) {
            return this.formatar(info, coluna);
          } else {
            return coluna;
          }
        });

        let info = {};

        _.each(titulos, (titulo, nome) => {
          let chave = !isNaN(titulo) ? "'" + titulo : titulo;
          chave = chave.replace('.', '');
          info[chave] = retorno[nome];
        });

        return info;

        /*
        retorno = _.mapKeys(retorno, (value, key) => {
          return _.get(titulos, key);
        });

        return retorno;
        */
      });

      return lista;

    },
    groupedData: function() {
      if (!this.relatorio.result) return [];

      let grouped = this.dadosFiltrados;

      if ( this.ordem ) {
        grouped = _.orderBy(grouped, [this.ordem.name], [this.ordem.direction]);

        grouped = _.orderBy(
            grouped, 
            linha => { 
                if ( !isNaN(linha[this.ordem.name]) ) {
                    return parseFloat(linha[this.ordem.name]);
                } else {
                    return linha[this.ordem.name];
                }
            },
            this.ordem.direction
        );
      }

      let groups

      if ( this.relatorio.pivot ) {
        groups = [this.relatorio.result.columns[0].name];
      } else {
        groups = this.relatorio.result.group_cols.map(item => {
          return item.name;
        });
      }

      if (groups.length) {
        grouped = grouped.reduce((r, o) => {
          groups
            .reduce(
              (group, key, i, { length }) =>
                (group[o[key]] = group[o[key]] || (i + 1 === length ? [] : {})),
              r
            )
            .push(o);

          return r;
        }, {});
      }

      return grouped;
    },

    exibirOpcoesFiltro: function () {
      return this.opcoesFiltro.filter((item) => item.label !== null && ( !this.search || item.label.toString().toUpperCase().indexOf(this.search.toUpperCase())) >= 0)
        .slice(0, this.slice_filtro + 1);
    },

    opcoesFiltroSelecionadas: function () {
      return this.opcoesFiltro.filter((item) => item.selecionado);
    },

    arquivoCsv: function() {
      return "Relatório " + this.relatorio.title + ".csv";
    },
    arquivoXls: function() {
      return "Relatório " + this.relatorio.title + ".xls";
    },
    j_data: function() {
      let tmp = [];
      tmp = this.relatorio.result.data;
      let groupedArray = _.orderBy(tmp, ["especialidade"], ["asc"]);
      return groupedArray;
    },
    dataToDownload: function() {
      return this.flatResult();
    },
    parmsFilled: function() {
      let filled = {};

      if ( this.relatorio ) {
        let inputs = this.relatorio.inputs;

        for (var i of inputs) {
          if (i.value != "" && i.value != undefined && i.value != null) {
            if (i.input_type == "select") {
              for (var opt in i.options) {
                if (i.options[opt][0] == i.value) {
                  filled[i.title] = i.options[opt][1];
                }
              }

              if ( i.type == 'per-date' && i.value == 'l' ) {
                let from = _.get(this.parms, ':' + i.id + '-from');
                let to = _.get(this.parms, ':' + i.id + '-to');

                if ( from || to ) {
                  filled[i.title] = ( from ? this.$util.getFormatDate(from) : '' ) + ' a ' + ( to ? this.$util.getFormatDate(to) : '' );
                }
              } else if ( i.type == 'per-date' && i.value == 'lh' ) {
                let from = _.get(this.parms, ':' + i.id + '-from');
                let to = _.get(this.parms, ':' + i.id + '-to');

                if ( from || to ) {
                  filled[i.title] = ( from ? this.$util.getFormatDate(from) + ' ' + from.substr(11,5) : '' ) + ' a '
                    + ( to ? this.$util.getFormatDate(to) + ' ' + to.substr(11,5) : '' );
                }
              } else if ( i.type == 'per-date' && i.value == 'ld' ) {
                let from = _.get(this.parms, ':' + i.id + '-from');

                if ( from ) {
                  filled[i.title] = ( from ? this.$util.getFormatDate(from) + ' ' + from.substr(11,5) : '' ) ;
                }
              } else if ( i.type == 'per-date' && i.value == 'lm' ) {

                let mes = _.get(this.parms, ':' + i.id + '-mes');

                if ( mes ) {
                  filled[i.title] = mes;
                }

              }
            } else {
              filled[i.title] = i.value;
            }
          }
        }

      }

      return filled;
    },
    fieldsToFile: function() {
      let fields = {};
      if ( this.relatorio && this.relatorio.result ) {
        let columns = this.relatorio.result.columns;
        for (var i in columns) {
          fields[columns[i].title] = columns[i].name;
        }
      }
      return fields;

      // id: "id_especialidade",
      // Especialidade: "st_especialidade",
      // cod: "st_codigo_cbo_3"
    },
    unidade_relatorio: function() {
        if ( this.relatorio && this.relatorio.id_uo ) { 
            return this.relatorio.id_uo; 
        }

        return _.get(this.parms, ':unidade');
    },

    nome_contratado: function() {
      const nomeContratado = _.get(this.parms, ':nome_contratado');
      return nomeContratado;
    },

    codigo_contratado: function() {
      const codigoContratado = _.get(this.parms, ':codigo_contratado');
      return codigoContratado;
    }

  },

  methods: {
    fechar_painel () { 
        clearInterval(this.func_refresh_painel);
        this.tempo_painel = null;
        this.atualizacao = null; 
    },

    ativar_painel (tempo) { 
        this.tempo_painel = tempo; 
        this.atualizacao = null; 

        this.func_refresh_painel = setInterval(() => { 
            this.load();
        }, tempo * 1000 * 60);
    },

    nextload () { 
        this.$nextTick(() => {
            this.load();
        });
    },

    compartilhar () { 

        $('[data-toggle="tooltip"]').tooltip('hide');
        this.printable = true;
        this.printableFont = {
            textDecoration: "none",
            color: "black"
        };

        document.body.classList.add("print-mode");

        this.$nextTick(() => {
            const html = document.getElementById('tabela-to-print').innerHTML;

            this.$refs.compart.abrir(this.relatorio.id, this.montar_parametros(), html);

            this.printable = false;
            this.printableFont = null;  
        }); 
    },

    fechar_modal (modal) { 
        $('#' + modal).modal('hide');
    },

    dimensao_selecao (selecionada) { 
      this.relatorio.dimensoes.forEach((item, idx) => {
        item.selecionada = ( idx === selecionada );
      });

      this.$nextTick(() => { 
        this.load();
      });
    },

    toggle_todos () { 
      let opcao = this.exibirOpcoesFiltro.find(item => {
        return !item.selecionado;
      });

      this.exibirOpcoesFiltro.forEach(item => {
        item.selecionado = opcao;
      });
    },

    tratar_erro (erro) {
      if ( erro && erro.indexOf('|') ) {
        return _.get(erro.split('|'), '0');
      }

      return erro;
    },

    incluir_linha () {
      let dados = _.transform(this.relatorio.result.config_cols, (r, v, k) => {
          r[k.trim()] = v ? null : '';
        });

      this.relatorio.result.data.push(dados);
    },

    atualizar_linha (linha, remove = false) {
      if ( remove ) {
        if ( !confirm('Confirma a exclusão do registro?') ) {
          return;
        }
      }

      this.$util.atualizar(this, {
        service: 'relatorios',
        func: 'atualizar_linha',
        dados: {
          query_id: this.relatorio.id,
          linha: linha,
          delete: remove,
        },
        reload: true,
        toast: true,
      });
    },

    load_csv() {
      if ( this.dados_csv ) {
        this.do_download_csv();
      } else {
        this.load(null, true);
      }
    },

    do_download_csv() {
      this.$store.commit("loading", true);

      let dataStr = "data:text/csv;charset=utf-8," + encodeURIComponent(this.dados_csv);
      let downloadAnchorNode = document.createElement("a");

      downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", 'relatorio.csv');
      document.body.appendChild(downloadAnchorNode);
      downloadAnchorNode.click();
      downloadAnchorNode.remove();

      this.$nextTick(() => {
        this.$store.commit("loading", false);
      });
    },

    atualizar_campos() {
      this.load();
    },

    config_campos() {
      this.dados_campos = _.cloneDeep(this.relatorio.result.config_cols);

      $('#camposModal').modal('show');
    },

    totalizar_pivot(dados, coluna = null, valor = null) {
      return dados.filter(item => !coluna || item[coluna.name] == valor)
        .reduce((total, carry) => total + parseFloat(_.get(carry, this.relatorio.result.columns[2].name)), 0);
    },

    listar(campo) {
      if (!campo || !this.relatorio.result) {
        return [];
      }

      return _.orderBy(
          _.map(
            _.uniqBy(this.relatorio.result.data, campo.name),
            (item) => {
              return { label: item[campo.name], selecionado: false };
            }
          ),
          "label"
        );
    },

    calc_percent (total, parte) {
      if ( !total )
        return null;

      return ( parte / total ) * 100;
    },

    condensar(quebra) {
      return quebra && quebra.length == 1 && quebra[0][this.relatorio.result.columns[0].name] == '=';
    },

    acessos() {
      this.$refs.acessos.abrir('App\\Query', this.relatorio.id);
    },
    campanha_selecao (tipo) {
      this.campanha = {
        campanha: tipo,
        texto: "",
        assunto: "",
        dados: this.dadosFiltrados,
        tem_link: false,
        tink_titulo: "",
        link: "",
      };

      $('#textoCampanhaModal').modal('show');
    },
    campanha_enviar () {
      this.$util.atualizar(this, {
        service: 'relatorios',
        func: 'campanha_enviar',
        dados: {
          ...this.campanha,
        },
        callback: () => {
          this.$toast.add({
            severity: "success",
            summary: "Campanha",
            detail: "Mensagens Enviadas.",
            life: 3000
          });
        },
        modal: 'textoCampanhaModal'
      });
    },
    addFiltroByGroup(item) {
      this.addFiltroModal(item);
    },
    share() {
      this.validate = false;
      $("#shareReportModal").modal('show');
    },
    enviar() {
        const html = document.getElementById('tabela-to-print').innerHTML;

        this.$util.atualizar(this, {
            service: 'relatorios',
            func: 'enviar',
            dados: {
                ...this.share_data,
                dados: this.relatorio,
                html: html,
            },
            modal: 'shareReportModal',
        });
    },
    flatResult() {
      if (!this.relatorio.result) return [];

      if (this.relatorio.result.group_cols.length == 2)
        return _.flatMap(this.groupedData, item => _.flatMap(item));
      else if (this.relatorio.result.group_cols.length == 1)
        return _.flatMap(this.groupedData);
      else return this.groupedData;
    },
    replaceFiltro(campo) {
      let index = this.filtros.findIndex(filtro => {
        return filtro.campo.name == campo.name;
      });

      if (index >= 0) {
        this.removerFiltro(index);
      }
    },
    addFiltroModal(campo) {
      this.opcoesFiltro = [];
      this.search =  "";
      this.campoFiltro = { ...campo };
      this.tipoFiltro = 'A';
      this.tipo_filtro_classe = false; 

      console.log('CF', this.campoFiltro);

      if (!this.campoFiltro || !this.relatorio.result) {
        this.opcoesFiltro = [];
      } else {
        let tem_lista_json = false; 

        this.opcoesFiltro = _.orderBy(
          _.flatMap(
            _.uniqBy(this.relatorio.result.data, this.campoFiltro.name),
            (item) => {
                let lista = [item[this.campoFiltro.name]]; 
                if ( item[this.campoFiltro.name] 
                    && String(item[this.campoFiltro.name]).slice(0,1) == '[' 
                    && String(item[this.campoFiltro.name]).slice(-1) == ']' ) {

                    lista = JSON.parse(item[this.campoFiltro.name]);
                    tem_lista_json = true; 
                    this.tipo_filtro_classe = true; 

                }

                if ( !lista )
                    return []; 

                return lista.map(itemlist => { return { label: itemlist, selecionado: false, json: tem_lista_json }; });
            }
          ),
          "label"
        );

        if ( tem_lista_json ) { 
            this.opcoesFiltro = _.orderBy(_.uniqBy(this.opcoesFiltro, 'label'), item => item.label ? item.label.toUpperCase() : '', 'asc');
        }
      }

      $("#filtroModal").modal("show");
    },
    addFiltroFromModal() {
      let lista = this.opcoesFiltro
        .filter(item => {
          return item.selecionado;
        })
        .map(item => {
          return item.label;
        });

      this.replaceFiltro(this.campoFiltro);

      this.filtros.push({
        campo: this.campoFiltro,
        tipo: this.tipoFiltro,
        valor: lista
      });

      this.fechar_modal('filtroModal');

      this.campoFiltro = null;
    },
    addFiltro(campo, valor) {
      if ( valor
        && !isNaN(valor)
        && this.filtros
        && this.filtros.find(item => item.campo == campo && item.valor.length == 1 && item.valor[0] == valor )
        && ( typeof valor == 'number' || ( typeof valor == 'string' && valor.indexOf('.') < 0 ) )
      ) {

        if ( Math.round(valor) == valor ) {
          if ( confirm('Deseja visualizar o atendimento #' + valor + '?') ) {
            this.$util.abrir_atendimento(this, valor);
            return;
          }
        }

      }

      this.replaceFiltro(campo);

      this.filtros.push({
        campo: campo,
        valor: [valor]
      });

      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    removerFiltro(index) {
      this.filtros.splice(index, 1);
    },
    agrupar(dados, quebra) {
      return _.groupBy(dados, quebra);
    },
    formatar(campo, valor) {
        //console.log(campo, valor);

      if (!campo.format && campo.type != "value") { 
        return valor; // ? "'" + valor : "";
      }

      switch (campo.type) {
        case "time":
        case "timestamp":
          return valor
            ? ( campo.format.substr(0,3) == 'H:i'
              ? valor.substr(11,5)
              : ( this.$util.getFormatDate(valor) + ( campo.format.substr(0,9) == 'd/m/Y H:i' ? ( ' ' + valor.substr(11,5) ) : '' ) ) )
            : "";

        case "computed":
        case "value":
            if ( valor === null || valor === undefined || valor === '' ) {
                return null;
            }

            if ( !isNaN(valor) && campo.format == 'MF' ) { 
                return moment.utc(valor * 60 * 1000).format("HH:mm");
            }

            if ( !isNaN(valor) && campo.format == 'min2time' ) { 
                return moment.utc(valor * 60 * 1000).format("HH:mm:ss");
            }

            if ( valor && isNaN(valor) && ( campo.format == 'D' ) ) {
                return this.$util.getFormatDate(valor);
            } 

            if ( isNaN(valor) || isNaN(campo.format) ) { 
                return valor;
            }

            return this.$util.formatNumber(valor, campo.format);

        default:
            return valor;
      }
    },
    totalizar(dados, campo, flat = 0, info_coluna = null) {
        if (flat) {
            if ( flat == 3 ) {
                dados = _.flatMap(dados, (item) => _.values(item));
                dados = _.flatMap(dados, (item) => _.values(item));
                dados = _.values(dados).flat();
            } else if ( flat == 2 ) {
                dados = _.flatMap(dados, (item) => _.values(item));
                dados = _.values(dados).flat();
            } else {
                dados = _.flatMap(dados);
            }
        }

        if ( !Array.isArray(dados) ) {
            return 0;
        }

        let total = dados.reduce((total, item) => {
            return total + ( ( isNaN(item[campo]) || !item[campo] ) ? 0 : parseFloat(item[campo]) );
        }, 0);

        if ( info_coluna && info_coluna.avg && dados.length ) { 
            total = total / dados.length;
        }

        return total; 
    },
    printTabela(landscape = null) {
      $('[data-toggle="tooltip"]').tooltip('hide');
      this.printable = true;
      this.printableFont = {
        textDecoration: "none",
        color: "black"
      };

      document.body.classList.add("print-mode");

      var configPrint = null;
      if(landscape) {
        configPrint = {
            styles: [
                "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                "https://kit-free.fontawesome.com/releases/latest/css/free.min.css",
                "https://api.klingo.app/css/estiloa4l.css",
            ]
        };
      } else { 
        configPrint = {
            styles: [
                "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                "https://api-externa.klingo.app/css/estiloprintlight.css",
            ]
        };
      }

      if ( _.get(this.relatorio, 'result.columns') && ( _.get(this.relatorio, 'result.data.length') > 3000 ) ) { 

        this.$nextTick(() => {

            const html = document.getElementById('tabela-to-print').innerHTML;

            this.$util.print_preview('imprimir/html', false, { html: html }, false);  

            this.$nextTick(() => {
                this.printable = false;
                this.printableFont = null;
            });

        });

      } else { 

        this.relatorio.result.columns
            ? this.$nextTick(() => {
                // this.scanForRasterization();

                this.$htmlToPaper("tabela-to-print", configPrint, () => {
                this.$nextTick(() => {
                    this.printable = false;
                    this.printableFont = null;
                });
                });
            })
            : this.$toast.add({
                severity: "error",
                summary: "Nenhum dado encontrado",
                detail: "Não foi possível imprimir.",
                life: 3000
            });

      }

      //   this.printableFont = null;
    },

    printEtiqueta(id) {
        console.log(id);

        console.log(this.relatorio.result);

        this.$util.atualizar(this, {
            service: 'etiquetas',
            func: 'imprimir_relatorio',
            dados: {
                id_etiqueta_layout: id,
                dados_relatorio: this.relatorio.result.data,
                config_cols: this.relatorio.result.config_cols,
            },
            toast: true,
            callback: (res) => {
                 if (res.status == "OK") {
                    let pdfWindow = window.open("");
                    pdfWindow.document.write(
                        "<html><head><title>Etiquetas</title></head><body><iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                            encodeURI(res.resposta) +
                            "'></iframe></body></html>"
                    );
                }
            }
        });

    },

    checkFields() {
      if (!this.relatorio.result.columns)
        this.$toast.add({
          severity: "error",
          summary: "Nenhum dado encontrado",
          detail: "Não foi possível gerar o arquivo.",
          life: 3000
        });
    },

    montar_parametros (csv = false) { 

        const html = document.getElementById('tabela-to-print').innerHTML;

        let dimensao = this.relatorio ? this.relatorio.dimensoes.find(item => item.selecionada) : null;
        let parametros = {
        id: this.id,
        ...this.parms,
        csv: csv,
        config_cols: this.dados_campos,
        tipo_detalhe: this.tipo_detalhe,
        dimensao: dimensao ? dimensao.column_name : null,
        html: html,
        };

        return parametros;

    },


    load(parms = null, csv = false) {

      if ( this.$store.state.loading ) {
        console.log('buscando...');
        return;
      }


      this.over_limit = false;
      this.dados_csv = null;

      if ( parms ) {
        this.parms = parms;
      } else if ( this.$refs.parametros ) {
        this.parms = this.$refs.parametros.obter_parametros();
      }

      if ( this.relatorio && this.relatorio.error ) {
        this.relatorio.error = "";
      }

      $('[data-toggle="tooltip"]').tooltip('hide');

      this.$store.commit("loading", true);

      //this.relatorio.result = "";

      if ( this.canceltoken ) {
          this.canceltoken.cancel('#BC#');
      }

      this.canceltoken = this.axios.CancelToken.source();

      let dimensao = this.relatorio ? this.relatorio.dimensoes.find(item => item.selecionada) : null;

      let query = {
        q: [{ name: "relatorios.show", parms: {
          id: this.id,
          ...this.parms,
          csv: csv,
          config_cols: this.dados_campos,
          tipo_detalhe: this.tipo_detalhe,
          dimensao: dimensao ? dimensao.column_name : null,
        } }]
      };

      const base = this.axios.defaults.baseURL;
      const redir = ( base.substr(0,5) == 'https'
        ? 'https://api-relatorio.klingo.app/api'
        : ''
      );

      this.axios.post(redir + '/aql?a=relatorio.show', query, {
            cancelToken: this.canceltoken.token
        })
        .then(res => {
          let titulo;

          if ( res.data["relatorios.show"].status == 200 && csv ) {
            this.over_limit = true;
            this.dados_csv = res.data["relatorios.show"].data.result.data;

            titulo = this.relatorio.title;

            this.do_download_csv();
          } else if ( res.data["relatorios.show"].status == 200 ) {
            this.relatorio = res.data["relatorios.show"].data;
            titulo = this.relatorio.title;
            this.over_limit = res.data["relatorios.show"].data.limit;
          } else if ( res.data["relatorios.show"].status == 403 ) {
            if ( this.relatorio ) {
              this.relatorio.result = null;
            }

            this.over_limit = res.data["relatorios.show"].data.limit;

            this.msg_erro = res.data["relatorios.show"].data.msg;

            if ( this.over_limit && this.relatorio ) {
              titulo = this.relatorio.title;
            } else {
              titulo = "Falha";
            }
          } else {
            titulo = "Falha";
          }

          if ( _.get(this.relatorio, 'unid.logo.arquivo.temporary_url') ) { 
            this.logo_url = _.get(this.relatorio, 'unid.logo.arquivo.temporary_url');
          }

          this.$forceUpdate();

          if ( this.pparms && this.pparms.inmodal ) { 

            //

          } else { 

            let breadcrumb;

            if ( !this.breadcrumb ) {
                breadcrumb = [
                { name: "Relatórios", path: "/relatorios" }
                ];
            } else {
                breadcrumb = _.cloneDeep(this.breadcrumb);
            }

            breadcrumb.push({
                name: titulo,
                path: "/relatorio/" + this.id
                });

            this.$store.commit("setBreadcrumb", breadcrumb);

          }

          this.atualizacao = this.$util.agora(); 

        })
        .catch(error => {
          if ( this.relatorio ) {
            this.relatorio.result = null;
            //this.relatorio = null;
          }
          console.log(error);
        })
        .finally(() => {
          this.$store.commit("loading", false);
          this.firstLoadDone = true;

          if ( !this.inmodal ) { 
            $('.modal').modal('hide');
          }
        });
    },

    scanForRasterization() {

        // CSS properties that trigger Chrome rasterization
        const rasterTriggers = [
            "transform",
            "filter",
            "backdrop-filter",
            "mix-blend-mode",
            "perspective",
            "isolation",
            "will-change",
            "box-shadow",
            "text-shadow",
            "background-blend-mode"
        ];

        const all = document.querySelectorAll("*");
        let warnings = 0;

        all.forEach(el => {
            let computed = window.getComputedStyle(el);
            let risk = false;

            rasterTriggers.forEach(prop => {
            if (computed[prop] && computed[prop] !== "none" && computed[prop] !== "auto" && computed[prop] !== "normal") {
                risk = true;
            }
            });

            if (computed.backgroundImage !== "none" && computed.backgroundImage.includes("gradient")) {
            risk = true;
            }

            if (risk) {
                el.classList.add("print-debug-raster");
                el.classList.remove("print-debug-ok");
                warnings++;
            } else {
                el.classList.add("print-debug-ok");
            }
        });

        console.warn(`🖨️ Print Debugger: ${warnings} raster-risk elements found`);
    }

  },

  created() {
    let parms = this.pparms ? this.pparms : this.$route.params;

    this.$store.commit("loading", false);

    _.forEach(parms, (item, chave) => {
      this.parms[':' + chave + '-disabled'] = false;

      // console.log('pps', chave, item);

      if ( chave != 'id' && chave != 'breadcrumb' && item ) {
        this.parms[':' + chave] = item;
        this.parms[':' + chave + '-disabled'] = true;
      } else if ( chave == 'breadcrumb' ) {
        this.breadcrumb = item;
      }
    });
  },
  mounted() {
    let parms = this.pparms ? this.pparms : this.$route.params;

    this.linked = parms.linked ? true : false;
    this.id = parms.id;
    this.dash_id = parms.dash_id;
    this.backlink = parms.backlink;

    if ( parms.filtros && parms.filtros.length ) {
      this.filtros = _.map(
          _.groupBy(parms.filtros, 'campo.column_name'),
          (items) => {
            return {
              campo: {
                name: items[0].campo.column_name ? items[0].campo.column_name : items[0].campo.name,
                title: items[0].campo.title,
              },
              valor: items.map(vl => vl.valor),
            };
          }
        );

      this.$nextTick(() => {
        this.$forceUpdate();
      });
    }

    this.load();

    let id_uo = this.$store.state.user.id_unidade_operacao;

    if ( parms && parms.unidade && !isNaN(parms.unidade) ) { 
      id_uo = parms.unidade;
    } 

    // console.log('parms', id_uo);

    if ( id_uo ) { 
      this.$util.loadItem(this, { 
        service: 'unidade_operacaos',
        func: 'index', 
        parms: { 
          logo: true, 
          where: { 
            id_unidade_operacao: id_uo
          }
        },
      })
      .then(res => { 
        this.logo_url = _.get(res, '0.logo.arquivo.temporary_url');
      });
    } 
  },
  updated() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }
};
</script>

<style>
@media print {
  /* Force a page break before this element */
  .page-break-before {
    page-break-before: always;
  }
  
  /* Force a page break after this element */
  .page-break-after {
    page-break-after: always;
  }
  
  /* Avoid page breaks inside this element */
  .no-page-break {
    page-break-inside: avoid;
  }

  /* Otimização da Impressão */
  body {
    font-family: Arial, sans-serif !important;
  }
}

/* Highlight layers that cause rasterization */
.print-debug-raster {
  outline: 2px dashed red !important;
  position: relative;
}

.print-debug-raster::after {
  content: "⚠ rasterize-layer";
  color: #fff;
  background: red;
  font-size: 10px;
  padding: 2px 4px;
  position: absolute;
  top: -12px;
  right: 0;
  z-index: 99999;
  opacity: 0.85;
}

/* Elements safe = green glow */
.print-debug-ok {
  outline: 1px solid #00c200 !important;
}
</style>

<style scoped>
.panel-fullscreen {
  display: block;
  z-index: 999999;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: auto;
}
</style>